module.exports = ["A+","A-","B+","B-","AB+","AB-","O+","O-"]


//////////////////
// WEBPACK FOOTER
// ./src/components/json/bloodgroup.json
// module id = UTZQ
// module chunks = 74